module.exports = __webpack_public_path__ + "media/geekbang.8b1cd842.mp4";